import React, { useCallback, useEffect, useState } from 'react';
import { Paper, Box, IconButton, Hidden } from '@mui/material';
import { useDropzone } from 'react-dropzone';
import { AddCircleOutline, Cancel } from '@mui/icons-material/';

const Dropzone = ({ width, imageId, handleDrag, handleDrop, file, onFileDropSuccess, onRemoveFile }) => {
  // const [selectedImages, setSelectedImages] = useState(null);

  // React.useEffect(() => {
  //   if (initFile) {
  //     const temp = [];
  //     temp.add(initFile);
  //     setSelectedImages(temp);
  //   }
  // }, []);

  const onDrop = useCallback((acceptedFile) => {
    // console.log(acceptedFile);
    // setSelectedImages(
    //   acceptedFile.map((file) => {
    //     return Object.assign(file, {
    //       preview: URL.createObjectURL(file),
    //     });
    //   })
    // );
    // console.log(acceptedFile[0]);
    if (acceptedFile.length > 0) {
      // setSelectedImages({ preview: URL.createObjectURL(acceptedFile[0]) });
      onFileDropSuccess(acceptedFile[0], imageId);
    }
  });

  const select_images = file ? (
    <>
      <img alt='' src={URL.createObjectURL(file)} style={{ width: width, height: width, objectFit: 'cover' }} />
      <IconButton sx={{ position: 'absolute', bottom: 0, right: 0 }} onClick={() => onRemoveFile(imageId)}>
        <Cancel />
      </IconButton>
    </>
  ) : null;

  const { getInputProps, getRootProps } = useDropzone({ onDrop, maxFiles: 1 });

  return (
    <Box component='div' style={{ width: width, height: width, position: 'relative' }}>
      <div
        draggable={true}
        id={imageId}
        onDragOver={(ev) => ev.preventDefault()}
        onDragStart={handleDrag}
        onDrop={handleDrop}>
        {file ? (
          select_images
        ) : (
          <>
            <div {...getRootProps()}>
              <input {...getInputProps()} />
              <Paper
                sx={{ textAlign: 'center', width: width, height: width, lineHeight: width + 10 + 'px' }}
                variant='outlined'>
                <AddCircleOutline />
              </Paper>
            </div>
          </>
        )}
      </div>
    </Box>
  );
};

export default Dropzone;
